import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Shell } from '@app/shell/shell.service';
import { PolicyEditorSettingsComponent } from './policy-editor-settings.component';
import { CustomRulesComponent } from './settings/custom-rules.component';
import { CustomPolicySettingsComponent } from './settings/custom-settings/custom-settings.component';
import { authGuard } from '@app/shared/guards/auth.guard';

const routes: Routes = [
  Shell.childRoutes([
    { path: '', redirectTo: '/policyeditor', pathMatch: 'full' },
    {
      path: 'policyeditor',
      component: PolicyEditorSettingsComponent,
      canActivate: [authGuard],
      children: [
        { path: '', redirectTo: 'customrules', pathMatch: 'full' },
        { path: 'customrules', component: CustomRulesComponent }, //customrules
        {
          path: 'policy/:customPolicy',
          component: CustomPolicySettingsComponent,
        },
      ],
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class PolicyEditorRoutingModule {}
